export default __webpack_public_path__ + "static/media/vi_next.942dfcab.mp4";